import script from "./ThemeToggle.vue?vue&type=script&lang=ts&setup=true"
export * from "./ThemeToggle.vue?vue&type=script&lang=ts&setup=true"

import "./ThemeToggle.vue?vue&type=style&index=0&id=47557242&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47557242"]])

export default __exports__